import { render, staticRenderFns } from "./CardVesselDocuments.vue?vue&type=template&id=fbb1ed76&"
import script from "./CardVesselDocuments.vue?vue&type=script&lang=js&"
export * from "./CardVesselDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports